import { useEffect, useState } from 'react';
import { Button, Flex, Select } from '@radix-ui/themes';

import * as Types from '@/types';
import NodeContainer from '../../Container';
import { NodeInput } from '../../../inputs';
import { WorkflowNodeProps } from '../..';

export type DefaultNodeProps = WorkflowNodeProps<Types.SignalNode> & {
  onCancel: () => void;
};

const SignalTypeSelect = ({
  signalType,
  onChange,
}: {
  signalType: Types.SignalType | undefined;
  onChange: (signalType: Types.SignalType) => void;
}) => (
  <Select.Root
    value={signalType}
    onValueChange={(value) => onChange(value as Types.SignalType)}
  >
    <Select.Trigger placeholder="Select Type" />
    <Select.Content>
      {Object.entries(Types.SignalType).map(([key, value]) => (
        <Select.Item key={key} value={value}>
          {key}
        </Select.Item>
      ))}
    </Select.Content>
  </Select.Root>
);

const DefaultNode = ({ id, data, onChange, onCancel }: DefaultNodeProps) => {
  const [signalType, setSignalType] = useState<Types.SignalType | undefined>(
    undefined,
  );

  const handleSave = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    if (!signalType) return;

    onChange(id, {
      signal: {
        ...data.signal,
        signalType,
      },
    });
  };

  return (
    <NodeContainer title="New Signal" signalType={signalType}>
      <Flex direction="column" gap="2" p="2">
        <NodeInput title="Signal Type">
          <SignalTypeSelect signalType={signalType} onChange={setSignalType} />
        </NodeInput>
        <Flex justify="between">
          <Button variant="ghost" size="1" m="2" onClick={onCancel}>
            Cancel
          </Button>
          <Button variant="ghost" size="1" m="2" onClick={handleSave}>
            Save
          </Button>
        </Flex>
      </Flex>
    </NodeContainer>
  );
};

export default DefaultNode;
